module.exports = __webpack_public_path__ + "media/images/common/slack-icon-d48bfc74669e88c57256d76b2d05b555.svg";